"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[282],{

/***/ 6737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ _cmsGradientBlock; },
/* harmony export */   "u": function() { return /* binding */ GradientBlock; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);



var _cmsGradientBlock = {
  label: 'Blaues Rechteck',
  name: 'GradientBlock',
  widget: 'object',
  summary: '',
  fields: [{
    label: 'Höhe',
    hint: '(in Prozent der Seitenhöhe)',
    name: 'height',
    widget: 'string',
    value_type: 'int',
    min: 10,
    max: 100,
    step: 10,
    required: false
  }]
};
function GradientBlock(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '60' : _ref$height;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"].dynamic([["393245089", [height + 'vh']]]) + " " + "gradient-block",
    children: ["\xA0", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
      id: "393245089",
      dynamic: [height + 'vh'],
      children: [".gradient-block.__jsx-style-dynamic-selector{margin-top:10rem;margin-bottom:3rem;width:100%;height:".concat(height + 'vh', ";background-image:var(--bg-gradient);}")]
    })]
  });
}

/***/ }),

/***/ 1994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ PageBlocks; },
  "P": function() { return /* binding */ _cmsPageBlocks; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2809);
// EXTERNAL MODULE: ./src/components/blue-image.tsx
var blue_image = __webpack_require__(3735);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(5988);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/dist/index.js
var dist = __webpack_require__(8093);
// EXTERNAL MODULE: ./src/components/trans-link.tsx
var trans_link = __webpack_require__(2331);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
;// CONCATENATED MODULE: ./src/components/author-card.tsx






function AuthorCard(_ref) {
  var data = _ref.data;
  var fullName = data.fullName,
      description = data.description,
      slug = data.slug,
      imageSrc = data.imageSrc,
      width = data.width,
      height = data.height;
  var _ref2 = description,
      compiledSource = _ref2.compiledSource;
  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("article", {
    className: "jsx-319933671",
    children: [imageSrc ? /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(blue_image/* BlueImage */.w, {
      alt: 'Portrait von ' + fullName,
      imageSrc: imageSrc,
      blue: true,
      width: width,
      height: height
    }) : null, /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("h3", {
      className: "jsx-319933671",
      children: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(trans_link/* TransLink */.H, {
        href: "authors/".concat(slug),
        children: fullName
      })
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("p", {
      className: "jsx-319933671" + " " + "serif",
      children: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(dist/* MDXRemote */.R, {
        compiledSource: compiledSource
      })
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "319933671",
      children: ["article.jsx-319933671 h3.jsx-319933671{margin-top:1.2rem;margin-bottom:2rem;}", "article.jsx-319933671 a{border:0;-webkit-transition:0.4s color;transition:0.4s color;}", "article.jsx-319933671 a:hover{color:var(--brand);}"]
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/blocks/authors-teaser.tsx




var _cmsAuthorsTeaser = {
  label: 'Author*innenvorschau',
  name: 'AuthorsTeaser',
  widget: 'object',
  summary: 'Alle',
  fields: [{
    label: 'placeholder',
    name: 'placeholder',
    widget: 'hidden',
    "default": ''
  }]
};
function AuthorsTeaser(_ref) {
  var allAuthors = _ref.allAuthors;
  if (!allAuthors) return null; // are they sorted?
  // TODO: layout when more than 3 authors

  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("div", {
    className: "jsx-2982109394 " + style["default"].dynamic([["2001074185", [allAuthors.length < 3 ? '47%' : '28%']]]) + " " + "side-by-side",
    children: [allAuthors.map(function (author) {
      return author !== undefined ? /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(AuthorCard, {
        data: author
      }, author.fullName) : null;
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "2982109394",
      children: [".side-by-side{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;margin-top:6rem;}", ".side-by-side article{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%;}", "@media (min-width:780px){.side-by-side article{max-width:47%;}.side-by-side article:nth-child(odd){margin-top:18vh;}}", "@media (min-width:1280px){.side-by-side article:nth-child(3n+1){margin-top:22vh;}.side-by-side article:nth-child(3n+2){margin-top:0;}.side-by-side article:nth-child(3n+3){margin-top:15vh;}}"]
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "2001074185",
      dynamic: [allAuthors.length < 3 ? '47%' : '28%'],
      children: ["@media (min-width:1280px){.side-by-side article{max-width:".concat(allAuthors.length < 3 ? '47%' : '28%', ";}}")]
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/blocks/big-quote.tsx


var _cmsBigQuote = {
  label: 'Großes Zitat',
  name: 'BigQuote',
  widget: 'object',
  summary: '{{fields.quote}}',
  fields: [{
    label: 'Zitat',
    name: 'quote',
    widget: 'string'
  }, {
    label: 'Autor*in',
    name: 'author',
    widget: 'string',
    required: false
  }, {
    label: 'Title',
    name: 'title',
    widget: 'string',
    required: false
  }]
};
function BigQuote(_ref) {
  var title = _ref.title,
      author = _ref.author,
      quote = _ref.quote;
  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("blockquote", {
    children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("p", {
      className: "big-font",
      style: {
        marginTop: '25vh',
        marginBottom: '2rem'
      },
      children: quote
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("footer", {
      children: /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("cite", {
        children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("b", {
          children: title
        }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("br", {}), author]
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/book-card.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function BookCard(_ref) {
  var data = _ref.data;
  var title = data.title,
      shortDescription = data.shortDescription,
      description = data.description,
      slug = data.slug;
  var serializedText = shortDescription ? shortDescription : description;
  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("article", {
    className: "jsx-97057028",
    children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("h3", {
      className: "jsx-97057028",
      children: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(trans_link/* TransLink */.H, {
        href: "books/".concat(slug),
        children: title
      })
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("p", {
      className: "jsx-97057028" + " " + "serif",
      children: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(dist/* MDXRemote */.R, _objectSpread({}, serializedText))
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "97057028",
      children: ["article.jsx-97057028:before{content:\" \";display:block;background-color:var(--brand);height:0.5rem;width:4.7rem;margin-top:4rem;}", "article.jsx-97057028 h3.jsx-97057028{margin-top:0.8rem;margin-bottom:2rem;}", "article.jsx-97057028 a{border:0;-webkit-transition:0.4s color;transition:0.4s color;}", "article.jsx-97057028 a:hover{color:var(--brand);}"]
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/blocks/books-teaser.tsx




var _cmsBooksTeaser = {
  label: 'Büchervorschau',
  name: 'BooksTeaser',
  widget: 'object',
  summary: 'Büchervorschau',
  fields: [{
    label: 'Bücher',
    name: 'books',
    widget: 'relation',
    multiple: true,
    min: 1,
    max: 3,
    collection: 'books',
    search_fields: ['title'],
    value_field: '{{slug}}'
  }]
};
function BooksTeaser(_ref) {
  var books = _ref.books,
      allBooks = _ref.allBooks;
  if (!allBooks) return null;
  var selectionWithData = books.map(function (slug) {
    return allBooks.find(function (book) {
      return book.slug === slug;
    });
  });
  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("div", {
    id: "\uD83D\uDCD6",
    className: "jsx-2982109394 " + style["default"].dynamic([["3979289601", [books.length < 3 ? '47%' : '28%']]]) + " " + "side-by-side",
    children: [selectionWithData.map(function (book) {
      return book !== undefined ? /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(BookCard, {
        data: book
      }, book.title) : null;
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "2982109394",
      children: [".side-by-side{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;margin-top:6rem;}", ".side-by-side article{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%;}", "@media (min-width:780px){.side-by-side article{max-width:47%;}.side-by-side article:nth-child(odd){margin-top:18vh;}}", "@media (min-width:1280px){.side-by-side article:nth-child(3n+1){margin-top:22vh;}.side-by-side article:nth-child(3n+2){margin-top:0;}.side-by-side article:nth-child(3n+3){margin-top:15vh;}}"]
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "3979289601",
      dynamic: [books.length < 3 ? '47%' : '28%'],
      children: ["@media (min-width:1280px){.side-by-side article{max-width:".concat(books.length < 3 ? '47%' : '28%', ";}}")]
    })]
  });
}
// EXTERNAL MODULE: ./src/components/blocks/gradient-block.tsx
var gradient_block = __webpack_require__(6737);
// EXTERNAL MODULE: ./src/components/blocks/spacer.tsx
var spacer = __webpack_require__(4153);
;// CONCATENATED MODULE: ./src/components/blocks/text-block.tsx





var _cmsTextBlock = {
  label: 'Textblock',
  name: 'TextBlock',
  widget: 'object',
  summary: '{{fields.body}}',
  fields: [{
    label: 'Inhalt',
    name: 'body',
    widget: 'markdown'
  }, {
    label: 'Maximale Breite',
    hint: '',
    name: 'maxWidth',
    widget: 'select',
    options: [{
      label: 'Volle Breite',
      value: 100
    }, {
      label: 'Halbe Breite',
      value: 50
    }, {
      label: '1/3 Breite',
      value: 33
    }],
    "default": {
      label: 'Halbe Breite',
      value: 50
    },
    required: false
  }]
};
var maxWidthDefault = {
  label: '',
  value: 50
};
function TextBlock(_ref) {
  var body = _ref.body,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? maxWidthDefault : _ref$maxWidth;
  var _ref2 = body,
      compiledSource = _ref2.compiledSource;

  var _maxWidth = maxWidth ? maxWidth : maxWidthDefault;

  var maxWidthString = "".concat(_maxWidth.value - 10, "vw"); //minus page margins

  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("section", {
    style: {
      maxWidth: maxWidthString
    },
    className: "jsx-2625019691",
    children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(dist/* MDXRemote */.R, {
      compiledSource: compiledSource,
      components: {
        img: blue_image/* BlueImage */.w
      }
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "2625019691",
      children: ["section.jsx-2625019691{margin:4rem 0;}"]
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/blocks/page-blocks.tsx


function page_blocks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function page_blocks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { page_blocks_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { page_blocks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var _cmsPageBlocks = {
  label: 'Abschnitte',
  name: 'blocks',
  widget: 'list',
  types: [spacer/* _cmsSpacer */.g, _cmsBigQuote, gradient_block/* _cmsGradientBlock */.T, _cmsTextBlock, _cmsBooksTeaser, _cmsAuthorsTeaser]
};
function PageBlocks(_ref) {
  var blocks = _ref.blocks,
      books = _ref.books,
      authors = _ref.authors;
  if (!blocks) return null;
  var comps = blocks.map(function (block, i) {
    switch (block.type) {
      case 'Spacer':
        return /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(spacer/* Spacer */.L, page_blocks_objectSpread({}, block), i);

      case 'BigQuote':
        return /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(BigQuote, page_blocks_objectSpread({}, block), i);

      case 'GradientBlock':
        return /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(gradient_block/* GradientBlock */.u, page_blocks_objectSpread({}, block), i);

      case 'BooksTeaser':
        return /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(BooksTeaser, page_blocks_objectSpread(page_blocks_objectSpread({}, block), {}, {
          allBooks: books
        }), i);

      case 'TextBlock':
        return /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(TextBlock, page_blocks_objectSpread({}, block), i);

      case 'BlueImage':
        return /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(blue_image/* BlueImage */.w, page_blocks_objectSpread({}, block), i);

      case 'AuthorsTeaser':
        return /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(AuthorsTeaser, page_blocks_objectSpread(page_blocks_objectSpread({}, block), {}, {
          allAuthors: authors
        }), i);
    }

    return null;
  });
  return /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
    children: comps
  });
}

/***/ }),

/***/ 4153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ _cmsSpacer; },
/* harmony export */   "L": function() { return /* binding */ Spacer; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);



var _cmsSpacer = {
  label: 'Abstandshalter',
  name: 'Spacer',
  widget: 'object',
  summary: '{{fields.height}}%',
  fields: [{
    label: 'Höhe',
    hint: '(in Prozent der Seitenhöhe)',
    name: 'height',
    widget: 'string',
    value_type: 'int',
    min: 10,
    max: 100,
    step: 10,
    required: false
  }]
};
function Spacer(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '40' : _ref$height;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"].dynamic([["2322400545", [height + 'vh']]]) + " " + "spacer",
    children: ["\xA0", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
      id: "2322400545",
      dynamic: [height + 'vh'],
      children: [".spacer.__jsx-style-dynamic-selector{height:".concat(height + 'vh', ";}")]
    })]
  });
}

/***/ }),

/***/ 3735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ _cmsImage; },
/* harmony export */   "w": function() { return /* binding */ BlueImage; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);



var _cmsImage = {
  label: 'Bild',
  name: 'BlueImage',
  widget: 'object',
  summary: 'Bild {{fields.alt}}',
  required: false,
  fields: [{
    label: 'Bild',
    name: 'imageSrc',
    widget: 'image'
  }, {
    label: 'Alternativtext',
    name: 'alt',
    hint: 'Wird statt dem Bild benutzt von z.B. Screenreadern oder Suchmaschinen.',
    widget: 'string'
  }, {
    label: 'Blaufilter',
    name: 'blue',
    widget: 'boolean',
    "default": true
  }, {
    label: 'Maximale Breite',
    hint: 'in Prozent',
    name: 'maxWidth',
    widget: 'select',
    options: ['50', '100'],
    "default": '50',
    required: false
  }]
};
var sizes = [1800, 900, 600, 300];
var formats = ['avif', 'webp', 'jpeg'];
function BlueImage(_ref) {
  var imageSrc = _ref.imageSrc,
      alt = _ref.alt,
      _ref$blue = _ref.blue,
      blue = _ref$blue === void 0 ? true : _ref$blue,
      className = _ref.className,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '50' : _ref$maxWidth,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
    style: {
      maxWidth: maxWidth + '%'
    },
    className: "jsx-3349978530" + " " + "img-wrapper ".concat(className !== null && className !== void 0 ? className : '', " ").concat(blue ? 'blue' : ''),
    children: [renderImage(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
      id: "3349978530",
      children: [".img-wrapper img{max-width:100%;height:auto;}", ".img-wrapper.blue{background-color:var(--brand);}", ".img-wrapper.blue img{-webkit-filter:grayscale(100%);filter:grayscale(100%);mix-blend-mode:luminosity;opacity:0.7;}"]
    })]
  });

  function renderImage() {
    var fileName = imageSrc.substring(0, imageSrc.lastIndexOf('.'));
    var srcBase = '/' + fileName;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("picture", {
      children: [formats.map(function (format) {
        var ext = format === 'jpeg' ? 'jpg' : format;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source", {
          type: 'image/' + format,
          srcSet: "".concat(srcBase, "-").concat(sizes[0], ".").concat(ext, " ").concat(sizes[0], "w, ").concat(srcBase, "-").concat(sizes[1], ".").concat(ext, " ").concat(sizes[1], "w, ").concat(srcBase, "-").concat(sizes[2], ".").concat(ext, " ").concat(sizes[2], "w, ").concat(srcBase, "-").concat(sizes[3], ".").concat(ext, " ").concat(sizes[3], "w"),
          sizes: "(max-width: ".concat(sizes[1], "px) 100vw, ").concat(sizes[1], "px")
        }, format);
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("img", {
        loading: "lazy",
        decoding: "async",
        width: width,
        height: height,
        src: "".concat(srcBase, "-").concat(sizes[0], ".jpg"),
        alt: alt !== null && alt !== void 0 ? alt : 'Bild'
      })]
    });
  }
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ _cmsMenuFields; },
/* harmony export */   "s": function() { return /* binding */ PrimaryNav; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var _components_trans_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2331);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7997);




var _cmsMenuFields = [{
  name: 'title',
  label: 'Titel',
  widget: 'string'
}, {
  label: 'Link',
  hint: 'z.B. `/verlag`,',
  name: 'href',
  widget: 'string'
}];
function PrimaryNav(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("nav", {
    className: "jsx-3527481330",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("ul", {
      className: "jsx-3527481330",
      children: data.map(renderLi)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
      id: "3527481330",
      children: ["nav.jsx-3527481330{margin-top:1rem;}", "ul.jsx-3527481330{list-style:none;padding:0;margin-top:0;}"]
    })]
  });

  function renderLi(_ref2) {
    var title = _ref2.title,
        href = _ref2.href;
    var isTopLink = href === '#';
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("li", {
      className: "jsx-1576111501",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_trans_link__WEBPACK_IMPORTED_MODULE_1__/* .TransLink */ .H, {
        href: href,
        className: 'switched' + (isTopLink ? ' toplink' : ''),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
        id: "1576111501",
        children: ["li.jsx-1576111501{font-family:var(--font-sans);font-weight:bold;display:inline-block;margin:0 0 0 1em;}", "a.jsx-1576111501{padding:0.3rem 0;border:none;}", "a.toplink.jsx-1576111501{display:none;}", "@media (min-width:700px){a.toplink.jsx-1576111501{display:block;}}"]
      })]
    }, href);
  }
}

/***/ }),

/***/ 2331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TransLink; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);


var TransLink = function TransLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      className = _ref.className;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  function onLinkClick(e) {
    if (window.location.href === href || window.location.pathname === href) {
      e.preventDefault();
      return false;
    }

    var isAnchor = href.startsWith('#') || href.startsWith('/#');
    var isHome = window.location.pathname === '/';
    if (isHome && isAnchor) return true;
    e.preventDefault();
    document.body.classList.add('fade-out');
    setTimeout(function () {
      void router.push(href);
    }, 400);
  }

  var prefetch = function prefetch() {
    void router.prefetch(href);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("a", {
    className: className,
    href: href,
    onClick: onLinkClick,
    onMouseEnter: prefetch,
    onPointerEnter: prefetch,
    children: children
  });
};
/*
export function useTransition(href: string) {
  const transition = function () {
    prefetch()

    void router.replace(href, undefined, {
        shallow: true,
      })
router.push(href)
    router.replace(window.location.href + '#l', undefined, {
      shallow: true,
    })
  }

  return { transition, prefetch }
}*/

/***/ })

}]);